// removed by extract-text-webpack-plugin
module.exports = {"guideEditSectionCollapsed":"_3D14S _1-OXK _3_vf0 _3Xg8b _2oaig _1GK4T _1bHiY iw2TU _1v96X","guideEditSectionDisabled":"_3rZOm KzoxQ","guideEditSectionCollapsedIcon":"_2gLPq _2qBNa","guideEditSectionCollapsedTitle":"qGWFe _3_vf0 _2qBNa","guideEditSectionCollapsedLink":"sj7rf iw2TU _2pX3d"};


//////////////////
// WEBPACK FOOTER
// ./reference/components/GuideEditSection.css
// module id = 2231
// module chunks = 3